import { TreeObject } from "./treeNode.model";
import { S1UserID } from "./userid";

export class UpdateUserPermissionsRequest {
    userId:S1UserID;
    treeObjectList:TreeObject[];
}